export const BACKEND_API_URL = "https://prod.joosup.com";
export const PAYPAL_CLIENT_ID =
  "AYZq5AXpGMWtphjlKGc7GVBQNlga3bOpVKV2Vuyqcse_2bWXON31tx0ygC04Gv6GAYhwZ_vRQUaJvbhu";
export const PAYPAL_MERCHANT_ID = "E3WCGQVXP4EL2";
